import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchRfidOnRouteReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getRfidOnRouteReport',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, {
    startDate: moment(payload.params.startDate).format('YYYY-MM-DD'),
    endDate: moment(payload.params.endDate).format('YYYY-MM-DD'),
    outboundImpcs: payload.params.outboundImpcs,
    inboundImpcs: payload.params.inboundImpcs,
  });
};

export default apiFetchRfidOnRouteReport;
